import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { ContentSectionState } from "./content-section.model";

const ACTION_PREFIX = "[Content Section]";
export const CONTENT_SECTION_ACTION_TYPE = {
	get: `${ACTION_PREFIX} Get`,
	getSuccess: `${ACTION_PREFIX} Get Success`,
	getFail: `${ACTION_PREFIX} Get Fail`,
};

/**
 * @deprecated - [fabric-deprecated]
 */
@Injectable({
	providedIn: "root",
})
export class ContentSectionAction {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentValue.getContentSectionGroup) instead
	 */
	get(name: string): Action {
		return createCachedGetAction(
			{
				type: CONTENT_SECTION_ACTION_TYPE.get,
				payload: name,
			},
			{ cacheKey: `${CONTENT_SECTION_ACTION_TYPE.get} ${name}` }
		);
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getSuccess(content: ContentSectionState, name: string): ActionWithPayload {
		return createGetSuccessAction(
			{
				type: CONTENT_SECTION_ACTION_TYPE.getSuccess,
				payload: content,
			},
			`${CONTENT_SECTION_ACTION_TYPE.get} ${name}`
		);
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getFail(error: AppError): ActionWithPayload {
		return {
			type: CONTENT_SECTION_ACTION_TYPE.getFail,
			payload: error,
		};
	}
}
